module.exports = __webpack_public_path__ + "img/add_green.439a9095.svg";